import React from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

// The sticky bar at the bottom of every pass.
//
// Apply stays disabled until a dry run has been seen. The dry run and the real
// apply run the same server code path and return the same report, so reading one
// is the only way to know what the other will do — and making that the required
// order is cheaper here than it ever was with a pair of JUnit methods.
//
// The gate says so on the panel and not only in a title attribute. A greyed-out
// button whose explanation needs a hover is indistinguishable from a broken one,
// and on the merges pass — where the gate matters most — that reads as a page that
// accepted the decisions and then refused to do anything with them.
export default function ApplyPanel({
  decidedCount,
  total,
  dryRunSeen,
  applying,
  destructive,
  applyLabel,
  onDryRun,
  onApply,
}) {
  if (decidedCount === 0) return null

  return (
    <div className="sticky-panel-bottom curation-apply-panel">
      <div className="d-flex align-items-center gap-3">
        <span>
          <strong>{decidedCount}</strong> decided of {total}
        </span>

        <Button variant="outline-secondary" onClick={onDryRun} disabled={applying}>
          {applying && <Spinner as="span" size="sm" className="me-2" />}
          Dry run
        </Button>

        <Button
          variant={destructive ? 'danger' : 'primary'}
          onClick={onApply}
          disabled={applying || !dryRunSeen}
          title={dryRunSeen ? undefined : 'Read a dry run first'}
        >
          {applying && <Spinner as="span" size="sm" className="me-2" />}
          {applyLabel || `Apply ${decidedCount}`}
        </Button>
      </div>

      {!dryRunSeen && (
        <div className="text-muted small mt-1">
          Run the dry run first — apply unlocks once you have read its report.
        </div>
      )}
    </div>
  )
}
